<template>
  <card @click="click">
    <article class="media">
      <figure class="media-left">
        <div class="image is-40x40 is-circular" >
          <img v-if="imageUrl" :src="imageUrl">
        </div>
      </figure>
      <div class="media-content">
        <div class="content left" :class="[!hasContentInRightSlot? 'is-fullwidth': '']">
          <strong class="content-title title-text" v-if="leftTitle">{{ leftTitle }}</strong>
          <div class="is-flex">
            <div class="is-primary is-cursor-pointer domain-url" @click="openUrl">{{domain}}</div>
            <div class="is-primary is-cursor-pointer " v-if="hirerEmail">&nbsp; . &nbsp; {{hirerEmail}}</div>
          </div>
        </div>
        <div>
<!--          <div class="has-text-right">-->
<!--            <strong v-if="rightTitle">{{ rightTitle }}</strong>-->
<!--          </div>-->
          <div class="rightSubtitle">
<!--            <span >Request to join {{boardName}} Job Board: <strong @click="handleAction('approve-company')" class="is-cursor-pointer approve">Approve</strong> or <strong @click="handleAction('reject-company')" class="reject is-cursor-pointer">Reject</strong></span>-->
            <button @click="handleAction('approve-company')" class="button  is-primary">Approve</button>
            <button @click="handleAction('reject-company')" class="button  is-danger">Reject</button>

          </div>
        </div>
      </div>
    </article>
  </card>
</template>

<script>
import Card from '@/components/general/card'
import DropdownModal from '@/components/dropdown-modal'
import Spinner from 'vue-simple-spinner'

export default {
  components: {
    Card,
    DropdownModal,
    Spinner
  },
  props: {
    company: {
      type: Object
    },
    imageUrl: {
      type: String,
      required: false
    },
    leftTitle: {
      type: String,
      required: false
    },
    rightTitle: {
      type: String,
      required: false
    },
    leftSubtitle: {
      type: String,
      required: false
    },
    rightSubtitle: {
      type: String,
      required: false
    },
    companyId: {
      type: String
    },
    boardId: {
      type: String
    },
    companyHandler: {
      type: Function
    },
    boardName: {
      type: String
    }
  },
  computed: {
    hasContentInRightSlot () {
      if (this.rightTitle || this.rightSubtitle) {
        return true
      } else if (this.$slots.rightTitle || this.$slots.rightSubtitle) {
        return true
      }
      return false
    },
    hasContentInRightTitleSlot () {
      if (this.rightTitle || this.$slots.rightTitle) {
        return true
      }
      return false
    },
    domain () {
      if (this.company) {
        return this.company.domain || ''
      }
      return ''
    },
    hirerEmail () {
      if (this.company) {
        return this.company.hirerEmail || ''
      }
    }
  },
  mounted () {
    console.log('test pick clicked', this.company)
  },
  methods: {
    handleAction (indicator) {
      this.companyHandler(indicator, {
        boardId: this.boardId,
        companyId: this.companyId
      })
    },
    click () {
      this.$emit('click')
    },
    openUrl () {
      window.open(`https://` + this.company.domain, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

strong {
  color: $black;
}

.content {
  max-width: 35vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.content-subtitle, .content-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.media-content {
  height: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}
.media-content > div {
  width: 50%;
}

.media div.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0;
  height: 100%;
  height: 40px;
}

.rightSubtitle{
  display: flex; justify-content: flex-end;
  margin-top: 10px;
  gap: 16px;
}
.is-fullwidth {
  max-width: 100%;
}

.domain-url{
  font-weight: 600;
  font-size: 14px;
  color: #44c7f0;
}

@media screen and (max-width: $tablet) {
  .content {
    max-width: none;
  }
  .content.left {
    margin-right: 4px;
    max-width: 60%;
  }
  .rightSubtitle{
    margin-top: 50px;
  }
}
.approve{
  color: #53c8f0 ;
}
.reject{
  color:#d65861
}

.modal-button{
  display: flex;
  justify-content: flex-end;
}

.title-text{
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/companies/request-companies-card.vue